import { render, staticRenderFns } from "./NewDeliveryOrderCustomer.vue?vue&type=template&id=8630acfe&scoped=true&"
import script from "./NewDeliveryOrderCustomer.vue?vue&type=script&lang=js&"
export * from "./NewDeliveryOrderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewDeliveryOrderCustomer.vue?vue&type=style&index=0&id=8630acfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8630acfe",
  null
  
)

export default component.exports